import { render } from "./Processed_Payrolls.vue?vue&type=template&id=3624a166"
import script from "./Processed_Payrolls.vue?vue&type=script&lang=js"
export * from "./Processed_Payrolls.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__